import { observable, decorate, action } from 'mobx'
import { AuthenticationDetails } from 'amazon-cognito-identity-js'
import cognitoUser from '../cognito-objects/cognitoUser'

const initialState = {
  user: {
    email: '',
    password: '',
    isAuthenticating: false
  }
}

class LoginStore {
  constructor (rootStore) {
    this.user = {
      ...initialState.user
    }
    this.rootStore = rootStore.stores
  }

  handleChange (value, name) {
    this.user[name] = value
  }

  setEmail (email) {
    this.user.email = email
  }

  authenticate (event) {
    event.preventDefault()
    this.user.isAuthenticating = true
    const authenticationData = {
      Username: this.user.email,
      Password: this.user.password
    }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    const user = cognitoUser(this.user.email)
    const loginStoreObj = this
    user.authenticateUser(authenticationDetails, {
      onSuccess: result => {
        this.rootStore.userStore.fetchUserInfo(result.accessToken.payload.sub)
      },
      onFailure: error => {
        loginStoreObj.user.isAuthenticating = false
        this.rootStore.notificationStore.sendErrorNotification('Erro', 'E-mail ou Senha inválidos')
      }
    })
  }

  resetState () {
    this.user = {
      ...initialState.user
    }
  }
}

decorate(LoginStore, {
  user: observable,
  handleChange: action,
  authenticate: action,
  resetState: action,
  setEmail: action
})

export default LoginStore



// WEBPACK FOOTER //
// ./src/stores/loginStore.js